import { render, staticRenderFns } from "./BatteryDisplay.vue?vue&type=template&id=067bfb9a&scoped=true&"
import script from "./BatteryDisplay.vue?vue&type=script&lang=ts&"
export * from "./BatteryDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./BatteryDisplay.vue?vue&type=style&index=0&id=067bfb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067bfb9a",
  null
  
)

export default component.exports